import api from './api';
import { User } from '../types/index';

// Auth (login/refresh/logout) é 100% no Core (services/core.ts). Aqui só o
// perfil resolvido: o backend do Task devolve req.user (identidade do Core +
// papel na empresa ativa) em GET /auth/me.
export const authService = {
  async getProfile(): Promise<User> {
    const response = await api.get('/auth/me');
    return response.data.data;
  },
};
